module.exports = __webpack_public_path__ + "img/girl_1.5018f800.svg";